<template lang="pug">
.container.grid-lg
  filter-component
  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      row(
        v-for="analise in list"
        :analise="analise"
        :key="analise.id"
        :to="{ name: 'app.analises.minhasAnalises.show', params: { id: analise.id } }"
      )
    .my-2.text-right(v-if="pages > 1")
      btn-paginate(
        :page="page",
        :pages="pages",
        :count="count",
        @go-page="goPage",
        @prev-page="prevPage",
        @next-page="nextPage"
      )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FilterComponent from "./Filter.vue"
import Row from "../Row.vue"

export default {
  vuex: { "analises/minhasAnalises": vuexDefaultMapping },
  components: { FilterComponent, Row },
  data() {
    return { q: {} }
  },
  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },
  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
